export const isProduction = () => process.env.NODE_ENV === "production";
export const isDataDogEnv = () =>
  process.env.REACT_APP_ENV === "staging" ||
  process.env.REACT_APP_ENV === "production";
export const isLocalhost = () =>
  process.env.NODE_ENV !== "production" &&
  process.env.REACT_APP_ENV === "development";
